import { defineMessages } from "react-intl";

export const commonMessages = defineMessages({
  name: {
    id: "common.name",
    defaultMessage: "Name",
  },
  description: {
    id: "common.description",
    defaultMessage: "Description",
  },
  edit: {
    id: "common.edit",
    defaultMessage: "Edit",
  },
  cancel: {
    id: "common.cancel",
    defaultMessage: "Cancel",
  },
  close: {
    id: "common.close",
    defaultMessage: "Close",
  },
  delete: {
    id: "common.delete",
    defaultMessage: "Delete",
  },
  submit: {
    id: "common.submit",
    defaultMessage: "Submit",
  },
  addUser: {
    id: "common.addUser",
    defaultMessage: "Add User",
  },
  save: {
    id: "common.save",
    defaultMessage: "Save",
  },
  publish: {
    id: "common.publish",
    defaultMessage: "Publish",
  },
  unpublish: {
    id: "common.unpublish",
    defaultMessage: "Unpublish",
  },
  import: {
    id: "common.import",
    defaultMessage: "Import",
  },
  defaultMode: {
    id: "common.defaultMode",
    defaultMessage: "All Company Content",
  },
  noInnioMode: {
    id: "common.noInnioMode",
    defaultMessage: "No Company Content",
  },
  innioTrainingsMode: {
    id: "common.innioTrainingsMode",
    defaultMessage: "INNIO Trainings",
  },
  researcherMode: {
    id: "common.researcherMode",
    defaultMessage: "Researcher",
  },
  companyMode: {
    id: "common.companyMode",
    defaultMessage: "All Company Content",
  },
  chatRequestEntityTooLarge: {
    id: "common.request_entity_too_large",
    defaultMessage: "Request Entity Too Large",
  },
  chatRequestTooManyTokens: {
    id: "common.request_too_many_tokens",
    defaultMessage: "Request Exceeds Token Limit",
  },
  newUpdateAvailable: {
    id: "common.new_update_available",
    defaultMessage: "New version available. Click on reload to update.",
  },
  reload: {
    id: "common.reload",
    defaultMessage: "Reload",
  },
  documentsNr: {
    id: "common.documents-nr",
    defaultMessage:
      "{count, plural, one {{count} Document} other {{count} Documents}}",
  },
  ingesting: {
    id: "common.ingesting",
    defaultMessage:
      "{count, plural, =0 {Ingesting... ({count} Documents)} one {Ingesting... ({count} Document)} other {Ingesting... ({count} Documents)}}",
  },
  source_warning: {
    id: "common.source_warning",
    defaultMessage: "WARNING: {warning}",
  },
  readonly: {
    id: "common.readonly",
    defaultMessage: "Readonly",
  },
  canEdit: {
    id: "common.canEdit",
    defaultMessage: "Can Edit",
  },
  selectAll: {
    id: "common.selectAll",
    defaultMessage: "Select All",
  },
  noAccess: {
    id: "common.noAccess",
    defaultMessage: "No Access",
  },
  search: {
    id: "common.search",
    defaultMessage: "Search",
  },
  createdBy: {
    id: "common.createdBy",
    defaultMessage: "Created by: {name}",
  },
  addToFavorites: {
    id: "common.addToFavorites",
    defaultMessage: "Add to favorites",
  },
  removeFromFavorites: {
    id: "common.removeFromFavorites",
    defaultMessage: "Remove from favorites",
  },
  moreActions: {
    id: "common.moreActions",
    defaultMessage: "More actions",
  },
});
